var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriangleExleminationMark = function SvgTriangleExleminationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.343c-.8 0-1.768.548-2.584 2.02l-6.06 10.9c-.76 1.372-.728 2.454-.32 3.149.407.693 1.334 1.248 2.904 1.248H12c.042 0 .083.003.123.01h5.937c1.564 0 2.492-.554 2.9-1.249.41-.695.444-1.777-.316-3.147l-6.06-10.91C13.768 3.892 12.8 3.343 12 3.343Zm-.123 18.817H5.94c-1.9 0-3.433-.685-4.198-1.99-.765-1.302-.618-2.975.302-4.634l6.06-10.9C9.068 2.9 10.45 1.843 12 1.843c1.55 0 2.932 1.055 3.895 2.793l2.94 5.29 3.12 5.62c.92 1.66 1.065 3.333.299 4.636-.767 1.302-2.299 1.988-4.194 1.988H12a.752.752 0 0 1-.123-.01Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.994 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};
export default SvgTriangleExleminationMark;